import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Calendar, ArrowRight } from 'lucide-react';

const BookingCTA = () => {
  return (
    <section id="booking" className="py-24 bg-stone-950 relative overflow-hidden">
      {/* Background Decorative Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-emerald-500/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-teal-500/5 rounded-full blur-3xl" />
      </div>

      <div className="max-w-4xl mx-auto px-6 relative z-10">
        <div className="bg-gradient-to-br from-stone-800/80 to-stone-800/40 border border-stone-700/50 rounded-3xl p-8 md:p-12 text-center">
          {/* Icon */}
          <div className="w-16 h-16 mx-auto mb-6 bg-emerald-500/10 rounded-2xl flex items-center justify-center">
            <Calendar className="w-8 h-8 text-emerald-400" />
          </div>

          {/* Content */}
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Ready to Book Your Stay?
          </h2>
          <p className="text-stone-300 text-lg mb-8 max-w-2xl mx-auto">
            Check availability and reserve your riverfront retreat. Whether you're planning a fishing trip, family getaway, or peaceful escape, we can't wait to host you.
          </p>

          {/* CTA Button */}
          <Link to="/book">
            <Button
              size="lg"
              className="bg-emerald-600 hover:bg-emerald-500 text-white px-10 py-6 text-lg rounded-full transition-all duration-300 hover:shadow-xl hover:shadow-emerald-500/30 hover:-translate-y-1 group"
            >
              View Booking Calendar
              <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
          </Link>

          {/* Additional Info */}
          <p className="text-stone-500 text-sm mt-6">
            Questions? Email us at info@staytranquil.ca
          </p>
        </div>
      </div>
    </section>
  );
};

export default BookingCTA;
